import { Injectable } from '@angular/core';
import { BaseService } from '../infra/base-service';
import { HttpClient } from '@angular/common/http';
import {
  DetalhesContato,
  DadosVenda,
  ResponseContatosLista,
  ParamRemoverDadosVenda,
} from '../interfaces/lista-contato/lista-contato.interface';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ContatosService extends BaseService {
  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);

  }

  async obterContatosLista(
    idLista: number,
    pagina: number,
    quantidade: number
  ): Promise<ResponseContatosLista> {
    return await this.get<ResponseContatosLista>(
      `listadecontato/listarcontatos?idLista=${idLista}&pagina=${pagina}&quantidade=${quantidade}`
    );
  }

  async obterDetalhesContato(
    idContato: string,
    idLista: number
  ): Promise<DetalhesContato> {
    return await this.get<DetalhesContato>(
      `listadecontato/dadoscontato?idContato=${idContato}&idLista=${idLista}`
    );
  }

  async adicionarAnotacao(
    idContato: string,
    idLista: number,
    anotacoes: string
  ): Promise<boolean> {
    return await this.post<boolean>('listadecontato/gravaranotacao', {
      idContato,
      idLista,
      anotacoes,
    });
  }

  async converterContato(dadosVenda?: DadosVenda): Promise<number> {
    return await this.post<number>(
      'listadecontato/salvardadosvenda',
      dadosVenda
    );
  }

  async removerVendaContato(dadosVenda: ParamRemoverDadosVenda): Promise<boolean> {
    return await this.post<boolean>(
      'listadecontato/removervenda',
      dadosVenda
    );
  }
}
